import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TypeTableHead } from "../../type/componentsType/TkTable";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "経営者でなくなった年月日",
    keyword: "noOwnerDate",
    type: "text",
  },
  {
    title: "経営者でなくなった理由",
    keyword: "noOwnerReason",
    type: "text",
  },
  {
    title: "理由",
    keyword: "reason",
    type: "text",
  },
  {
    title: "廃止・休止が確認できる書類",
    keyword: "downloadLink",
    type: "downloadLink",
    downloadBase64: true,
  },
  {
    title:
      "社会福祉施設等、特定介護保険施設等又は申出施設等の名称、被共済職員数",
    keyword: "maStaffNum",
    type: "nodeInLine",
  },
  {
    title: "共済契約者番号",
    keyword: "aContractorNo",
    type: "text",
  },
  {
    title: "共済契約者名",
    keyword: "aCorpName",
    type: "text",
    text: "",
  },
];

const headList: TypeTableHead[] = [
  { headTitle: "帳票名", align: "left" },
  { headTitle: "記号番号", align: "left" },
  { headTitle: "決裁日", align: "left" },
];

const schema = {};

export { schema, fakeTableList, headList };
